import { render } from "./KPIWarning.vue?vue&type=template&id=235fd788&scoped=true"
import script from "./KPIWarning.vue?vue&type=script&lang=js"
export * from "./KPIWarning.vue?vue&type=script&lang=js"

import "./KPIWarning.vue?vue&type=style&index=0&id=235fd788&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235fd788"]])

export default __exports__